var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-select',{attrs:{"value":_vm.formattedValue,"options":_vm.values,"multiple":_vm.multiple,"disable":_vm.disable},on:{"change":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }